import classNames from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BreakIcon from '@swf/core/assets/break-icon.svg';
import ResponsibleGamingIcon from '@swf/core/assets/icons/18-logo-white-outlines.svg';
import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';
import type { Modal } from '@swf/core/models/modal';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import styles from './RegulatoryHeaderSE.scss';
import SjalvtestIcon from './assets/sjalvtest.svg';
import SpelgranserIcon from './assets/spelgranser.svg';
import SpelpausIcon from './assets/spelpaus.svg';

const RegulatoryHeaderSE: React.FC = () => {
  const depositLimitPath = useSelector(select.account.getDepositLimitPath);
  const helpResponsibleGaming = useResolver(ResolverTag.HelpResponsibleGaming);
  const helpRgRegulatorSe = useResolver(ResolverTag.HelpRGRegulatorSE);
  const helpRgSe = useResolver(ResolverTag.HelpRGSE);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const rgRegulatorSe = useResolver(ResolverTag.RGRegulatorSE);

  const { modal } = useDispatch<Dispatch>();

  const openAfterLogin = (locationParams: Modal) =>
    isAuthenticated
      ? modal.enqueue(locationParams)
      : modal.enqueue({ path: '/auth/login', locationState: locationParams });

  const openRestrictDepositLimit = () => openAfterLogin({ path: depositLimitPath });

  const openSelfExcludeFor24Hours = () => openAfterLogin({ path: '/notifications/panic-button' });

  return (
    <>
      <div className={styles.regulatoryRestriction}>
        <a href={rgRegulatorSe} target="_blank" rel="noopener noreferrer">
          <span className={styles.regulatoryText}>Stödlinjen.se</span>
        </a>
        <a
          href={helpResponsibleGaming}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.regulatoryIcon}
        >
          <ResponsibleGamingIcon width={18} height={18} />
        </a>
      </div>
      <div className={styles.regulatoryHeader}>
        <a
          href={helpRgSe}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.regulatoryIcon}
        >
          <SpelpausIcon width={69} height={20} />
        </a>
        <SpelgranserIcon
          width={82}
          height={20}
          className={styles.regulatoryIcon}
          onClick={openRestrictDepositLimit}
        />
        <a
          href={helpRgRegulatorSe}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.regulatoryIcon}
        >
          <SjalvtestIcon width={68} height={20} />
        </a>
        <div
          className={classNames(styles.regulatoryIcon, styles.textIcon)}
          onClick={openSelfExcludeFor24Hours}
        >
          <BreakIcon width={18} height={18} />
          <div className={styles.regulatoryText}>24 tim paus</div>
        </div>
      </div>
    </>
  );
};
export default RegulatoryHeaderSE;
